var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{class:[`text-subtitle-1`]},[_c('h4',[_vm._v("Skill(s)")])]),_vm._l((_vm.skill_list),function(item,i){return _c('v-row',{key:i},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(item.skill)+" ")])],1)}),_c('v-divider')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }